import entries from "lodash/entries";
import groupBy from "lodash/groupBy";
import { WMProfile } from "PFApp/types/activity_form/manage_roles_form_schema";
import { Stack } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { getAttribute } from "PFCore/helpers/get_attribute";
import { getProfileName } from "PFCore/helpers/profile";
import { useCustomTypes } from "PFCore/helpers/use_custom_types";

import css from "./profile_info.module.scss";

type ProfileInfoProps = {
  profile: WMProfile;
};

export const ProfileInfo = ({ profile }: ProfileInfoProps) => {
  const { getCustomTypeById } = useCustomTypes();

  const valuesByType = groupBy(profile.pills, "custom_type_id");
  return (
    <Stack gap={null} className={css.root}>
      <Typography variant="labelBold" textOverflow="clip" title={getProfileName(profile)}>
        {getProfileName(profile)}
      </Typography>
      {entries(valuesByType).map(([customTypeId, customValues]) => {
        const text = customValues.map(({ text }) => text).join(", ");
        const title = customTypeId
          ? `${getAttribute(getCustomTypeById(Number(customTypeId)), "displayAs")}: ${text}`
          : "";
        return (
          <Typography
            key={customTypeId}
            variant="labelRegular"
            title={title}
            className={css.secondaryText}
            textOverflow="clip"
          >
            {text}
          </Typography>
        );
      })}
    </Stack>
  );
};
